import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";

export const IconPageLock: React.FC<CentralIconBaseProps> = (props) => {
  return <CentralIconBase {...props} ariaLabel="page-lock"><path d="M13.75 16.75H20.25V21.25H13.75V16.75Z" stroke="currentColor" strokeWidth="1.5" strokeLinecap="square"/><path d="M14.75 16C14.75 14.7574 15.7574 13.75 17 13.75C18.2426 13.75 19.25 14.7574 19.25 16V16.75H14.75V16Z" stroke="currentColor" strokeWidth="1.5" strokeLinecap="square"/><path d="M10.75 21.25H4.75V2.75H19.25V10.75" stroke="currentColor" strokeWidth="1.5" strokeLinecap="square"/></CentralIconBase>;
};

export default IconPageLock;
